// extracted by mini-css-extract-plugin
module.exports = {"left":"styles_left__Jdmi7","right":"styles_right__Cuvi_","counter":"styles_counter__zBe0P"};